import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../models/RootState";
import { EventData, MarketGroup, MatchOdds } from "../../models/EventData";
import moment from "moment";
// import Script from "next/script";
import axios from "axios";
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Card,
  Grid,
  Box,
  Tab,
} from "@mui/material";
import "./SportRadarMatchOdds.scss";
import lock from "../../assets/images/Lock.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Betslip from "../BetSlip/BetSlip";
import { BsData } from "../../models/BsData";
import { UserBet } from "../../models/UserBet";
import { addExchangeBet, fetchOpenBets, getAllmarketsData } from "../../store";
import { useParams } from "react-router-dom";
import OpenBets from "../OpenBets/OpenBets";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import cricket from "../../assets/images/sports/cricket.svg";
import tennis from "../../assets/images/sports/tennis.svg";
import soccer from "../../assets/images/sports/soccer.svg";
import { toast } from "react-toastify";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { useInterval } from "../../Hooks/useInterval";
import OddsGrid from "./OddsGrid";
import LiveStream from "../../components/LiveStream/LiveSteam";
import {
  checkStompClientSubscriptions,
  subscribeWsForEventOdds,
  unsubscribeAllWsforEvents,
} from "../../websockets/websocket";
import { isMobile } from "react-device-detect";
import { TopicUrls } from "../../models/sportsBookState";

type StoreProps = {
  eventInfo: EventData;
  eventMarkets: MatchOdds[];
  bets: BsData[];
  openBetsData: UserBet[];
  fetchOpenBets: (eventId, sportId) => void;
  addExchangeBet: (data: BsData) => void;
  loggedIn: boolean;
  premiumEventInfo: any;
  topicUrls: TopicUrls;
};

export const SportRadarMatchOdds: React.FC<StoreProps> = (props) => {
  const {
    eventInfo,
    eventMarkets,
    addExchangeBet,
    fetchOpenBets,
    openBetsData,
    bets,
    premiumEventInfo,
    topicUrls
  } = props;

  const [displayMarketGroups, setDisplayMarketGroups] =
    useState<MarketGroup[]>();
  const [eventId, setEventId] = useState<string>("");
  const [openBetSlip, setOpenBetSlip] = useState<boolean>(false);
  const [selectedbet, setSelectedbet] = useState<string>("");
  const [selectedbetIndex, setSelectedbetIndex] = useState<string>("");
  const [openBets, setOpenBets] = useState<boolean>(true);
  const { sportId, competitionId } = useParams();
  const [value, setValue] = React.useState<string>("3");
  const [liveStream, setLiveStream] = useState<boolean>(true);
  const [scorecardID, setScorecardID] = useState<string>("");

  const loadSportRadar = (selector: string, widget: string, matchId: string) => {
  const id = selector.replace(".", "") + "-script";

  const old = document.getElementById(id);
  if (old) old.remove();

  const script = document.createElement("script");
  script.id = id;

  script.innerHTML = `
(function(a,b,c,d,e,f,g,h,i){
a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},
i.l=1*new Date,
i.o=f,
g=b.createElement(c),
h=b.getElementsByTagName(c)[0],
g.async=1,
g.src=d,
g.setAttribute("n",e),
h.parentNode.insertBefore(g,h))
})(window,document,"script",
"https://ws-cdn001.akamaized.net/8ee45b574e2781d581b0b0a133803906/widgetloader",
"SIR",
{
theme:false,
language:"en"
});

SIR("addWidget","${selector}","${widget}",{
layout:"double",
scoreboard:"extended",
momentum:"extended",
collapseTo:"momentum",
matchId:${matchId}
});
`;

  document.body.appendChild(script);
};

  const [openMarket, setOpenMarket] = useState([
    "1x2",
    "Handicap",
    "Total",
    "Winner",
  ]);

  const disabledStatus = [
    "suspended",
    "closed",
    "suspended-manually",
    "deactivated",
  ];
  const marketEnableStatus = ["active", "open"];
  const marketDisableStatus = ["deactivated", "cancelled", "settled"];
  const eventEnableStatus = ["in_play", "upcoming"];

  useEffect(() => {
    setScorecardID("");
    if (eventInfo?.eventId) {
      axios
        .get(
          `https://lt-fn-cdn001.akamaized.net/techablesoftware/en/Etc:UTC/gismo/match_info/m` +
          eventInfo?.eventId
        )
        .then((result) => {
          var MatchId = result.data.queryUrl;
          var str = MatchId;
          let matches = str.match(/(\d+)/);
          setScorecardID(matches[0]);
        });
    }
  }, [eventInfo]);

  useEffect(() => {
  if (!scorecardID) return;

  loadSportRadar(".sr-widget-1", "match.lmtPlus", scorecardID);
  loadSportRadar(".sr-widget-2", "match.lmtPlus", scorecardID);
}, [scorecardID]);

  useEffect(() => {
    if (eventMarkets) getAndSetMarkets(eventMarkets);
  }, [eventMarkets]);

  useEffect(() => {
    if (eventInfo && eventId !== eventInfo.eventId)
      setEventId(eventInfo.eventId);
  }, [eventInfo]);

  useInterval(() => {
    if (eventInfo) {
      fetchOpenBets(eventInfo.eventId, eventInfo.sportId);
    }
  }, 1000 * 6);

  // useEffect(() => {
  //   if (eventId && eventId !== "") {
  //     subscribeWsForEventOdds(
  //       sessionStorage.getItem("psProviderId"),
  //       eventInfo.eventId
  //     );
  //   }
  //   return () => {
  //     unsubscribeAllWsforEvents();
  //   };
  // }, [isSocketConnected(), eventId]);

  useEffect(() => {
    if (bets && bets.length > 0) {
      setSelectedbet(
        bets[0]?.runnerId + bets[0]?.runnerName + bets[0]?.marketId
      );
    } else {
      setSelectedbet("");
    }
  }, [bets]);

  // useEffect(() => {
  //   const topicUrlPayload: TopicUrls = {
  //     prBaseUrl: topicUrls?.prBaseUrl,
  //     prTopic: topicUrls?.prTopic
  //   }
  //   let refreshInterval = setInterval(() => {
  //     checkStompClientSubscriptions(topicUrlPayload);
  //   }, 30 * 1000);
  //   return () => {
  //     clearInterval(refreshInterval);
  //   };
  // }, []);

  let newData = [];

  const getAndSetMarkets = async (data) => {
    data?.reduce((oldV, newV) => {
      // show marketname in same order
      let index = oldV.findIndex((item) => item.marketName === newV.marketName);

      if (oldV.length && index !== -1) {
        let mrFound = false;
        oldV[index].completeMarket = oldV[index].completeMarket.map((market) => {
          if (market.marketId !== newV.marketId) return market;
          mrFound = true;
          return newV;
        });
        if (!mrFound) {
          oldV[index] = {
            ...oldV[index],
            completeMarket: [...oldV[index].completeMarket, newV],
          };
        }
      } else {
        // If a new market comes, it will be added to it.
        oldV.push({ marketName: newV.marketName, completeMarket: [newV] });
      }
      // return array.
      return oldV;
    }, newData);

    // sorting for runnername
    for (let i = 0; i < newData.length; i++) {
      newData[i].completeMarket.sort((a, b) => {
        let x = a.marketId;
        let y = b.marketId;
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      });
    }

    if (newData?.length) {
      const priority = (name: string) => {
        const normalized = name.toLowerCase();
        if (normalized === "1x2" || normalized.startsWith("winner")) return 0;
        if (normalized === "handicap") return 1;
        if (normalized === "total") return 2;
        return 3;
      };

      setDisplayMarketGroups(
        newData.sort((a, b) => {
          const priorityDifference = priority(a.marketName) - priority(b.marketName);
          return priorityDifference || a.marketName.localeCompare(b.marketName);
        })
      );
    } else {
      setDisplayMarketGroups([]);
    }
  };

  const handleChange = (panel: string) => {
    // setExpanded(isExpanded ? panel : false);
    let index = openMarket.indexOf(panel);
    if (index > -1) {
      openMarket.splice(index, 1);
      setOpenMarket([...openMarket]);
    } else {
      setOpenMarket((preState) => [...preState, panel]);
    }
  };

  const setBetData = (data) => {
    if (disabledStatus.includes(data.status.toLowerCase())) {
      setSelectedbet("");
      toast.error(`${data.status}`);
    } else {
      let betData = {
        sportId: sportId,
        competitionId: competitionId,
        eventId: eventInfo?.eventId,
        eventName: eventInfo?.eventName,
        betType: "BACK",
        sessionOutcome: 0,
        stakeAmount: 0,
        ...data,
      };
      addExchangeBet(betData);
    }
  };

  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <div className="sport-radar-ctn">
      <div className="left-side-ctn">
        <Card className="event-heading">
          {eventInfo ? (
            <>
              <Typography gutterBottom component="div" className="event-name">
                <div>
                  {eventInfo?.sportName === "Cricket" ? (
                    <img src={cricket} alt="cricket" />
                  ) : eventInfo?.sportName === "Soccer" ? (
                    <img src={soccer} alt="soccer" />
                  ) : eventInfo?.sportName === "Tennis" ? (
                    <img src={tennis} alt="tennis" />
                  ) : null}{" "}
                </div>
                {eventInfo && eventInfo.eventName && eventInfo.eventName}
                <br />
                {isMobile
                  ? eventInfo &&
                  eventInfo.openDate &&
                  moment(eventInfo.openDate).format("MMM DD YYYY hh:mm A")
                  : null}
              </Typography>
              {isMobile ? null : (
                <Typography gutterBottom component="div" className="date">
                  {eventInfo &&
                    eventInfo.openDate &&
                    moment(eventInfo.openDate).format("MMM DD YYYY hh:mm A")}
                </Typography>
              )}
              <Typography gutterBottom component="div" className="date">
                MIN:
                {eventInfo &&
                  eventInfo?.markets?.matchOdds[0]?.limits.minBetValue}
                , MAX:{eventInfo?.markets?.matchOdds[0]?.limits.maxBetValue}
              </Typography>
            </>
          ) : (
            <Typography gutterBottom component="div" className="event-name">
              !!!!No Data !!!!
            </Typography>
          )}
        </Card>
        <Typography gutterBottom component="div" className="web-view">
          <div className="widgets">
            <div>
              <div className="sr-widget sr-widget-2"></div>
            </div>
          </div>
        </Typography>
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChangeTab}
                aria-label="lab API tabs example"
                className="mob-view"
              >
                <Tab label="Open Bets" value="2" />
                <Tab label="Score" value="3" />
                {/* <Tab label="Live Stream" value="4" /> */}
              </TabList>
            </Box>
            <TabPanel value="2">
              <OpenBets openBets={openBetsData} provider="sp" />
            </TabPanel>
            {/* <TabPanel value="4">
              <LiveStream eventID={eventInfo?.eventId} />
            </TabPanel> */}
            <TabPanel value="3">
              <Typography gutterBottom component="div" className="mob-view">
                <div className="widgets">
                  <div>
                    <div className="sr-widget sr-widget-1"></div>
                  </div>
                </div>
              </Typography>
            </TabPanel>
          </TabContext>
          <div className="accordion-section">
            {displayMarketGroups && displayMarketGroups.length > 0
              ? displayMarketGroups.map((marketGroup, index) => {
                return (
                  <Accordion
                    // expanded={
                    //   expanded === marketGroup.marketName || index < 2
                    // }
                    expanded={openMarket.includes(marketGroup?.marketName)}
                    onChange={() => {
                      handleChange(marketGroup?.marketName);
                    }}
                    key={index}
                    className="market-according"
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                      className="market-according-accordion-summary"
                    >
                      <Typography sx={{ flexShrink: 0 }}>
                        {marketGroup?.marketName}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className="accordion-detail-section">
                      {marketGroup?.completeMarket?.map((market, idx) => {
                        return (
                          <React.Fragment
                                key={market?.marketId || `${marketGroup?.marketName}-${idx}`}
                            >
                            {marketDisableStatus.includes(
                              market.status.toLowerCase()
                            ) ? null : (
                              <>
                                {/* <div>{market?.status}</div> */}
                                <Grid container spacing={2}>
                                  {market?.runners?.length > 0 &&
                                    market.status !== "" &&
                                    eventEnableStatus.includes(
                                      eventInfo?.status?.toLowerCase()
                                    ) &&
                                    marketEnableStatus.includes(
                                      market.status.toLowerCase()
                                    ) ? (
                                    market?.runners?.map((d, idx) => {
                                      return (
                                        <React.Fragment
                                              key={d?.runnerId || `${market?.marketId}-runner-${idx}`}
                                          >
                                          {marketEnableStatus.includes(
                                            d.status.toLowerCase()
                                          ) && d?.backPrices?.length > 0 ? (
                                            <>
                                              <Grid
                                                item
                                                md={
                                                  market.runners.length %
                                                    3 ===
                                                    0
                                                    ? 4
                                                    : 6
                                                }
                                                xs={12}
                                                key={idx.toString()}
                                                onClick={() => {
                                                  setBetData({
                                                    marketName:
                                                      market?.marketName,
                                                    marketId:
                                                      market?.marketId,
                                                    marketType:
                                                      market?.marketType,
                                                    oddValue:
                                                      d?.backPrices[0]?.price,
                                                    runnerName: d?.runnerName,
                                                    runnerId: d?.runnerId,
                                                    status: market?.status,
                                                  });
                                                  setSelectedbetIndex(
                                                    d?.runnerId +
                                                    idx +
                                                    market.marketId +
                                                    d?.runnerName
                                                  );
                                                }}
                                                className="grid1"
                                              >
                                                <OddsGrid
                                                  data={d}
                                                  marketId={market.marketId}
                                                  selectedbet={selectedbet}
                                                  mainValue={
                                                    d?.backPrices[0]?.price
                                                  }
                                                />
                                              </Grid>
                                              {bets.length > 0 &&
                                                selectedbetIndex ===
                                                d.runnerId +
                                                idx +
                                                market.marketId +
                                                d?.runnerName ? (
                                                <Grid
                                                  item
                                                  md={6}
                                                  xs={12}
                                                  className="mob-view"
                                                >
                                                  <Betslip
                                                    page={"sportradar"}
                                                  />
                                                </Grid>
                                              ) : null}
                                            </>
                                          ) : (
                                            <Grid
                                              item
                                              md={6}
                                              xs={12}
                                              key={`idx-${d?.runnerId}`}
                                              className="grid1"
                                            >
                                              <div className="lock-section">
                                                <img
                                                  src={lock}
                                                  className="lock"
                                                  alt="lock-img"
                                                />
                                              </div>
                                            </Grid>
                                          )}
                                        </React.Fragment>
                                      );
                                    })
                                  ) : (
                                    <>
                                      <Grid
                                        item
                                        md={6}
                                        xs={12}
                                        className="grid1"
                                      >
                                        <div className="lock-section">
                                          <img
                                            src={lock}
                                            className="lock"
                                            alt="lock-img"
                                          />
                                        </div>
                                      </Grid>{" "}
                                      <Grid item xs={6} className="grid1">
                                        <div className="lock-section">
                                          <img
                                            src={lock}
                                            className="lock"
                                            alt="lock-img"
                                          />
                                        </div>
                                      </Grid>
                                    </>
                                  )}
                                </Grid>
                              </>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </AccordionDetails>
                  </Accordion>
                );
              })
              : null}
          </div>
        </Box>{" "}
      </div>
      <div className="right-side-ctn">
        <div className="content-ctn">
          {/* <Accordion
            expanded={liveStream}
            onChange={() => setLiveStream(!liveStream)}
            className="right-side-accordion"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
              className="right-side-accordion-summary"
            >
              <Typography sx={{ flexShrink: 0 }}>Live Stream</Typography>
            </AccordionSummary>
            <AccordionDetails className="accordion-detail-section open-bets-accordian">
              <LiveStream eventID={eventInfo?.eventId} />
            </AccordionDetails>
          </Accordion> */}
          <Accordion
            expanded={openBetSlip || bets.length > 0}
            onChange={() => setOpenBetSlip(!openBetSlip)}
            className="right-side-accordion"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="betslip-header"
              className="right-side-accordion-summary"
            >
              <Typography sx={{ flexShrink: 0 }}>
                BET SLIP ({bets && bets.length})
              </Typography>
            </AccordionSummary>
            {bets.length > 0 ? (
              <AccordionDetails className="accordion-detail-section">
                <Betslip page={"sportradar"} />
              </AccordionDetails>
            ) : null}
          </Accordion>

          <Accordion
            expanded={openBets || openBetsData?.length > 0}
            onChange={() => setOpenBets(!openBets)}
            className="right-side-accordion"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
              className="right-side-accordion-summary"
            >
              <Typography sx={{ flexShrink: 0 }}>
                Open Bets ({openBetsData?.length})
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="accordion-detail-section open-bets-accordian">
              <OpenBets openBets={openBetsData} provider="sp" />
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    bets: state.betslip.bets,
    openBetsData: state.betslip.openBets,
    eventMarkets: getAllmarketsData(state.sportsBook.eventMarkets),
    eventInfo: state.sportsBook.eventInfo,
    premiumEventInfo: state.sportsBook.premiumEventInfo,
    topicUrls: state?.sportsBook?.topicUrls
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: BsData) => dispatch(addExchangeBet(data)),
    fetchOpenBets: (eventId: string, sportId: string) =>
      dispatch(fetchOpenBets(eventId, sportId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SportRadarMatchOdds);
